import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

/**
 * Generates a professional PDF receipt for payments
 * @param {Object} payment - The payment data
 */
export const generateReceiptPDF = (payment) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    // -- Header & Branding --
    try {
        // Logo Integration
        doc.addImage('/IMG_5468.PNG', 'PNG', 20, 15, 45, 12);
    } catch (e) {
        // Fallback to text logo if image fails
        doc.setFont("helvetica", "bold");
        doc.setFontSize(22);
        doc.setTextColor(110, 60, 180);
        doc.text("Promotional", 20, 25);
        doc.setFontSize(22);
        doc.setTextColor(180, 180, 180);
        doc.text("LLC-FZ", 68, 25);
    }

    // Company Details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(80, 80, 80);
    const companyInfo = [
        "www.promotional.ae",
        "info@promotional.ae",
        "052-3622578",
        "Opal Tower, Business bay",
        "Dubai, U.A.E.",
        "TRN: 104101080000003"
    ];
    let currentY = 32;
    companyInfo.forEach(line => {
        doc.text(line, 20, currentY);
        currentY += 3.5;
    });

    // Receipt Title & ID (Right Side)
    doc.setFontSize(24);
    doc.setTextColor(0, 0, 0);
    doc.text("PAYMENT RECEIPT", pageWidth - 20, 25, { align: "right" });

    doc.setFontSize(10);
    doc.text(`# ${payment.paymentId}`, pageWidth - 20, 32, { align: "right" });

    // Amount Received (Right Side Highlight)
    doc.setFillColor(240, 240, 240);
    doc.roundedRect(pageWidth - 70, 38, 50, 12, 2, 2, "F");
    doc.setFont("helvetica", "bold");
    doc.text("Amount Received", pageWidth - 45, 43, { align: "center" });
    doc.setFontSize(12);
    doc.text(`AED ${payment.amount.toFixed(2)}`, pageWidth - 45, 48, { align: "center" });

    // -- Payment Details Section --
    currentY = 65;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("Received From", 20, currentY);

    doc.setFont("helvetica", "normal");
    currentY += 6;
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(payment.customer || "N/A", 20, currentY);

    currentY += 15;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(80, 80, 80);

    // Details Grid
    const details = [
        ["Payment Date", new Date(payment.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })],
        ["Payment Method", payment.method || "N/A"],
        ["Reference Invoice", payment.invoice || "N/A"],
        ["Payment Status", payment.status || "Completed"]
    ];

    autoTable(doc, {
        startY: currentY,
        body: details,
        theme: 'plain',
        styles: { fontSize: 10, cellPadding: 2 },
        columnStyles: {
            0: { fontStyle: 'bold', cellWidth: 40, textColor: [100, 100, 100] },
            1: { cellWidth: 'auto' }
        },
        margin: { left: 20 }
    });

    const finalY = doc.lastAutoTable.finalY + 20;

    // -- Summary Box --
    doc.setFillColor(252, 252, 252);
    doc.setDrawColor(240, 240, 240);
    doc.rect(20, finalY, pageWidth - 40, 30, "FD");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text("Total Amount Received", 30, finalY + 12);

    doc.setFontSize(16);
    doc.text(`AED ${payment.amount.toFixed(2)}`, pageWidth - 30, finalY + 12, { align: "right" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text("This is an automated system-generated receipt. No signature required.", 30, finalY + 22);

    // -- Bank Details (Footer branding consistency) --
    let footerY = doc.internal.pageSize.height - 50;
    doc.setDrawColor(200, 200, 200);
    doc.line(20, footerY, pageWidth - 20, footerY);

    footerY += 5;
    doc.setFontSize(9);
    doc.text("Bank Name: WIO Bank", 20, footerY + 5);
    doc.text("Account Name: Promotional L.L.C-FZ", 20, footerY + 10);
    doc.text("IBAN: AE490860000009562434370", 20, footerY + 15);
    doc.text("BIC/SWIFT : WIOBAEADXXX", 20, footerY + 20);

    doc.setFont("helvetica", "bold");
    doc.text("Promotional LLC-FZ", pageWidth - 20, footerY + 5, { align: "right" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("www.promotional.ae | info@promotional.ae", pageWidth - 20, footerY + 10, { align: "right" });

    doc.save(`Receipt_${payment.paymentId}.pdf`);
};
